(() => {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
parcelRequire.register("lHPpx", function(module, exports) {

$parcel$export(module.exports, "initSlider", () => $fcd57e4676f84318$export$25bca1bc22cc4f64);
/**
 * Toggle active classes after clicking the slide indicator
 * @param {Object} element - The selected object from the html markup
 */ function $fcd57e4676f84318$var$switchSlide(element) {
    const slides = element.querySelectorAll(".slider_items--item");
    const indicator = element.querySelectorAll(".slider_indicator--item");
    if (slides.length > 0) slides[0].classList.add("active");
    if (slides.length > 1) {
        indicator[0].classList.add("active");
        indicator.forEach(function(item) {
            item.addEventListener("click", ()=>{
                slides.forEach(function(item) {
                    item.classList.remove("active");
                });
                indicator.forEach(function(item) {
                    item.classList.remove("active");
                });
                item.classList.add("active");
                slides[item.dataset.index].classList.add("active");
            });
        });
    }
}
function $fcd57e4676f84318$export$25bca1bc22cc4f64(element) {
    $fcd57e4676f84318$var$switchSlide(element);
}

});

})();
//# sourceMappingURL=slider.9716e30f.js.map
